var render = function render(){var _vm=this,_c=_vm._self._c;return _c('layout',{attrs:{"align-center":""}},[_c('template',{slot:"header"}),_c('template',{slot:"content"},[_c('v-responsive',[_c('v-container',{attrs:{"fill-height":""}},[_c('br'),_c('div',{staticClass:"text-not-found"},[_c('p',[_vm._v("Oops! The requested resource is not available.")])])])],1)],1),_c('template',{slot:"footer"})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }